/**
 * The foot of every screen.
 *
 * Small and quiet: a hairline, the product's name and whose it is, the year. It sits
 * below the content rather than fixed to the viewport, so it never covers a table's last row and
 * a short page does not carry a bar of chrome at the bottom of an empty field. Caption-sized at
 * zero tracking, which is the brand's rule for small text, and the muted ink that passes AA.
 */
import { Box, Typography } from '@mui/material';

import { semantic } from '@/theme/theme';

export function AppFooter(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={{
        borderTop: `1px solid ${semantic.border}`,
        px: { xs: 4, md: 8 },
        py: 4,
        maxWidth: 1600,
        width: '100%',
        mx: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        color: 'text.secondary',
      }}
    >
      <Typography variant="caption">Strategic Planning Hub · OPOC.us</Typography>
      <Typography variant="caption">© {year} OPOC.us. For OPOC staff.</Typography>
    </Box>
  );
}
